class QuantityInput extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (e) => {
      if (!e.target.classList.contains("quantity__button")) return;

      this.onButtonClick(e);
    });

    this.addEventListener("change", (e) => {
      if (e.target === this.input) this.validateQtyRules();
    });
  }

  connectedCallback() {
    this.validateQtyRules();
  }

  get input() {
    return this.querySelector("input");
  }

  onButtonClick(event) {
    event.preventDefault();
    const input = this.input;
    if (!input) return;

    const previousValue = input.value;
    event.target.name === "plus" ? input.stepUp() : input.stepDown();
    if (previousValue !== input.value)
      input.dispatchEvent(new Event("change", { bubbles: true }));
  }

  validateQtyRules() {
    const input = this.input;
    if (!input) return;

    const value = parseInt(input.value);
    if (input.min) {
      const min = parseInt(input.min);
      const buttonMinus = this.querySelector("[name='minus']");
      buttonMinus?.classList.toggle("disabled", value <= min);
    }
    if (input.max) {
      const max = parseInt(input.max);
      const buttonPlus = this.querySelector("[name='plus']");
      buttonPlus?.classList.toggle("disabled", value >= max);
    }
  }
}
if (!customElements.get("quantity-input")) {
  customElements.define("quantity-input", QuantityInput);
}
